import { render } from "./InstrumentBasisdaten.pug?vue&type=template&id=0a795b3b&lang=pug"
import script from "./InstrumentBasisdaten.js?vue&type=script&lang=js"
export * from "./InstrumentBasisdaten.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__